import { CLIENTS } from "@/data/mockData";

// Business Manager fittizi che raggruppano gli account pubblicitari (1 per cliente).
// Futuro: importati realmente dalla sincronizzazione Meta. La sincronizzazione
// importa SEMPRE tutto: la visibilità (VisibilityContext) controlla solo la UI.
// Business Manager: nessun dato mock. Gli asset pubblicitari verranno importati
// realmente dalla sincronizzazione Meta una volta collegato l'account.
const GROUPS = [];

export const BUSINESS_MANAGERS = GROUPS.map((bm) => ({
  ...bm,
  accounts: bm.clientIds
    .map((cid) => {
      const c = CLIENTS.find((x) => x.id === cid);
      return c ? { id: c.adAccountId, name: c.name, clientId: c.id } : null;
    })
    .filter(Boolean),
}));

export const bmOfAccount = {};
BUSINESS_MANAGERS.forEach((bm) => bm.accounts.forEach((a) => { bmOfAccount[a.id] = bm.id; }));
